// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_more_exp_first = /** @type {(inputs: {}) => string} */ () => {
	return `more expensive first`
};

const el_more_exp_first = /** @type {(inputs: {}) => string} */ () => {
	return `ακριβότερα πρώτα`
};

const ru_more_exp_first = /** @type {(inputs: {}) => string} */ () => {
	return `сначала дороже`
};

const he_more_exp_first = /** @type {(inputs: {}) => string} */ () => {
	return `יקר יותר קודם`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const more_exp_first = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.more_exp_first(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("more_exp_first", locale)
	if (locale === "en") return en_more_exp_first(inputs)
	if (locale === "el") return el_more_exp_first(inputs)
	if (locale === "ru") return ru_more_exp_first(inputs)
	if (locale === "he") return he_more_exp_first(inputs)
	return "more_exp_first"
};